import { market, sgoBillImageUrl } from '../../constants';

const zFillWithZeros = (text, width) => '0'.repeat(width - text.length) + text;

const billImageUrl = (orderId) =>
  `${sgoBillImageUrl}=${zFillWithZeros(orderId.toString(), 16)}0000&order=OK`;

export const defineBillImageByCountry = (billImage, orderId, source) => {
  switch (market) {
    case 'pe':
      return billImage;
    case 'cl':
      return source === 'MTO' ? billImage : billImageUrl(orderId);
    default:
      '';
  }
};

export const showOrdersInformativeAlert = () => market === 'pe';
